import SatelliteCard from './SatelliteCard.jsx';
import SolarObjectCard from './SolarObjectCard.jsx';

// Selection pane, wraps SatelliteCard (or SolarObjectCard for solar-system
// objects) for mobile display. When nothing is selected, shows a friendly
// empty state explaining how to select an object.

const MONO = 'var(--mono)';

export default function MobilePaneSelection({
  selected, tracked, observer, onFollow, onUntrack, onClose,
}) {
  if (!selected) {
    return (
      <div style={{
        padding: '30px 16px', textAlign: 'center',
        color: 'var(--txt-mute)', fontFamily: MONO, fontSize: 'var(--ui-body)',
        lineHeight: 1.6,
      }}>
        <div aria-hidden="true" style={{ fontSize: 28, marginBottom: 12, opacity: 0.4 }}>◎</div>
        <div role="heading" aria-level="2" style={{ fontWeight: 700, color: 'var(--txt-dim)', marginBottom: 8 }}>NOTHING SELECTED</div>
        <div>Tap a satellite on the globe, pick a pass from the Tonight tab, or browse the Visible-now list under More.</div>
      </div>
    );
  }

  // Solar-system objects ({type, data} from the solar views) get the same
  // SolarObjectCard the desktop right console renders (sat.solar-object-card).
  if (selected.type && selected.data) {
    return (
      <div style={{ paddingTop: 4 }}>
        <SolarObjectCard item={selected} onClose={onClose} />
      </div>
    );
  }

  return (
    <div style={{ paddingTop: 4 }}>
      <button onClick={onClose} className="og-selection-clear" aria-label="Clear selected object" style={{minHeight:44,width:"100%",marginBottom:6}}>Clear selection</button>
      <SatelliteCard inline compact
        satellite={selected}
        tracked={tracked === selected?.norad_id}
        observer={observer}
        onFollow={() => onFollow(selected)}
        onUntrack={onUntrack}
        onClose={onClose}
      />
    </div>
  );
}
